var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThankyou(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 75,
    viewBox: "0 0 120 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12766 34.1605L14.0967 3.8215C14.4662 2.88463 15.5253 2.42459 16.4622 2.7943L25.9861 6.55158C26.923 6.92106 27.383 7.98023 27.0133 8.9171L15.0443 39.2564C14.6748 40.1933 13.6156 40.6531 12.6788 40.2833L3.15486 36.5263C2.21799 36.1566 1.75819 35.0974 2.12766 34.1605Z",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0051 51.131L79.7745 46.3302",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6677 57.8397L72.1286 53.5753",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.504 63.9496L64.5565 60.8946",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8906 53.9148C24.9412 52.2619 24.7008 49.3418 26.3538 47.3924L30.6808 42.3134C32.3337 40.364 35.254 40.1236 37.2032 41.7766C39.1525 43.4293 39.3929 46.3493 37.74 48.2987L33.413 53.378C31.76 55.3273 28.8399 55.5677 26.8906 53.9148Z",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9497 59.9003C32.0003 58.2473 31.7602 55.3272 33.4129 53.3779L37.7401 48.2989C39.3928 46.3495 42.3131 46.1091 44.2625 47.762C46.2119 49.4147 46.452 52.3351 44.7993 54.2842L40.4721 59.3634C38.8191 61.3128 35.8991 61.5532 33.9497 59.9003Z",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0089 65.8857C39.0596 64.2328 38.8192 61.3127 40.4721 59.3634L44.7994 54.2841C46.4521 52.335 49.3724 52.0946 51.3217 53.7475C53.2709 55.4002 53.5113 58.3203 51.8583 60.2697L47.5313 65.3489C45.8784 67.2983 42.9583 67.5387 41.0089 65.8857Z",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0681 71.8712C46.1188 70.2183 45.8784 67.2982 47.5313 65.3488L51.8583 60.2698C53.5113 58.3204 56.4316 58.08 58.3807 59.733C60.3301 61.3857 60.5705 64.3058 58.9175 66.2551L54.5905 71.3344C52.9376 73.2838 50.0175 73.5242 48.0681 71.8712Z",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.769 43.8112L91.4415 42.0936L80.4951 34.0149L79.2408 33.1331C68.9067 34.8885 61.9787 29.2262 59.1585 26.2814C58.329 25.415 56.9599 25.3821 56.0676 26.1836C46.3775 34.8864 40.7661 32.6558 38.0416 30.0669C36.7315 28.8222 36.957 26.6766 38.478 25.7002C43.6864 22.3572 48.55 18.1259 52.0251 14.8282L51.4063 14.5964C49.2065 13.7721 46.8947 13.2859 44.5495 13.154L38.141 12.7941C37.3017 12.747 36.4598 12.7365 35.621 12.7904C34.1083 12.8877 32.5896 12.6347 31.1845 12.0468L26.5447 10.1053L15.1655 38.9492L24.1615 44.6227L27.0085 46.6239L30.6811 42.3135C32.3338 40.3639 35.2539 40.1237 37.2032 41.7764C39.1526 43.4293 39.393 46.3494 37.74 48.2988C39.393 46.3494 42.3131 46.109 44.2624 47.762C46.2118 49.4149 46.4522 52.335 44.7992 54.2843C46.4522 52.335 49.3723 52.0946 51.3216 53.7475C53.271 55.4002 53.5114 58.3205 51.8584 60.2697C53.5114 58.3205 56.4315 58.0801 58.3808 59.7328C60.3302 61.3858 60.5706 64.3061 58.9176 66.2552L57.1625 68.3155L61.0259 71.1669C63.1716 72.7503 66.1953 72.5685 68.0375 70.6408C69.8308 68.7647 69.9376 65.9406 68.5041 63.9497L70.4413 65.3793C72.6507 67.0098 75.7799 66.7596 77.5958 64.7003C79.3549 62.7054 79.3103 59.7786 77.6676 57.8397L78.756 58.6426C80.8627 60.1973 83.8236 60.0563 85.677 58.2071C87.6474 56.2412 87.6997 53.1612 86.0052 51.1311L87.639 52.3371C89.923 54.0225 93.1393 53.5897 94.8945 51.344C96.7269 48.9992 96.1635 45.5783 93.769 43.8112Z",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.582 11.1522L60.9375 10.0991C58.6896 9.74271 56.4053 10.487 54.8054 12.1054C51.5084 15.4407 45.2864 21.3304 38.4781 25.7003C36.957 26.6766 36.7313 28.822 38.0416 30.067C40.7659 32.6557 46.3773 34.8863 56.0676 26.1835C56.9599 25.382 58.3288 25.4149 59.1585 26.2812C61.9834 29.231 68.9284 34.9077 79.29 33.1257L94.8686 44.6228L104.605 38.3686L93.4864 10.1841L86.7283 12.6789C84.8541 13.3707 82.8335 13.5696 80.8603 13.257L75.6992 12.439",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.518 15.518L105.903 3.82139C105.534 2.88476 104.475 2.42472 103.538 2.7942L94.0138 6.55148C93.0769 6.92119 92.6171 7.98036 92.9866 8.917L104.956 39.2563C105.325 40.1931 106.385 40.6529 107.321 40.2835L116.845 36.5262C117.782 36.1565 118.242 35.0975 117.872 34.1607L113.519 23.1267",
    stroke: "black",
    strokeWidth: 3.50101,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyou);
export default __webpack_public_path__ + "static/media/thankyou.e952a5b22f5eff4ac5c11c7dcbb1d7de.svg";
export { ForwardRef as ReactComponent };